import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ClientPortalLayout from './Layout';
import { clientPortalFetch } from './api';

const NAVY = '#0f1f45';

const STATUS_COLORS = {
  pending: '#f59e0b', in_progress: '#3b82f6', hold: '#6b7280',
  completed: '#16a34a', sent_for_approval: '#8b5cf6', approved: '#16a34a',
  escalated: '#dc2626', cancelled: '#9ca3af',
};

function DashboardInner({ me }) {
  const [tasks, setTasks] = useState([]);
  const [ledger, setLedger] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    clientPortalFetch('/tasks').then(setTasks).catch(() => {});
    clientPortalFetch('/ledger').then(setLedger).catch(() => {});
  }, []);

  const pendingTasks = tasks.filter((t) => !['completed', 'cancelled', 'approved'].includes(t.status));
  const nextDue = pendingTasks
    .filter((t) => t.due_date)
    .sort((a, b) => new Date(a.due_date) - new Date(b.due_date))[0];

  return (
    <div>
      <div className="cp-cards" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 28 }}>
        <StatCard label="Pending Tasks" value={pendingTasks.length} onClick={() => navigate('/client-portal/tasks')} />
        <StatCard
          label="Ledger Balance"
          value={ledger ? formatCurrency(ledger.closing_balance) : '—'}
          onClick={() => navigate('/client-portal/ledger')}
          accent={ledger && ledger.closing_balance > 0 ? '#dc2626' : '#16a34a'}
        />
        <StatCard
          label="Next Due Date"
          value={nextDue ? formatDate(nextDue.due_date) : 'None'}
          onClick={() => navigate('/client-portal/tasks')}
        />
      </div>

      {me?.client?.is_referral_partner && me?.portal_settings?.show_referral !== false && (
        <div
          onClick={() => navigate('/client-portal/referral')}
          style={{
            background: '#fff7ed', border: '1px solid #fed7aa', borderRadius: 12,
            padding: '14px 18px', marginBottom: 24, fontSize: 13, color: '#9a3412', cursor: 'pointer',
          }}
        >
          You are a referral partner with this firm. View your commissions →
        </div>
      )}

      <div style={{ background: '#fff', borderRadius: 14, padding: '20px 22px', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
        <h3 style={{ fontSize: 15, fontWeight: 700, color: NAVY, margin: '0 0 14px' }}>Recent Tasks</h3>
        {tasks.length === 0 && <p style={{ color: '#9ca3af', fontSize: 13 }}>No tasks yet.</p>}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {tasks.slice(0, 5).map((t) => (
            <div key={t.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #f1f5f9' }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 500, color: '#111827' }}>{t.title}</div>
                <div style={{ fontSize: 12, color: '#9ca3af' }}>{t.task_number}{t.due_date ? ` · Due ${formatDate(t.due_date)}` : ''}</div>
              </div>
              <StatusPill status={t.status} />
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 700px) {
          .cp-cards { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </div>
  );
}

const StatCard = ({ label, value, onClick, accent }) => (
  <div onClick={onClick} style={{
    background: '#fff', borderRadius: 14, padding: '20px 22px', cursor: onClick ? 'pointer' : 'default',
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)', border: '1px solid transparent',
  }}
    onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#e5e7eb'; }}
    onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'transparent'; }}
  >
    <div style={{ fontSize: 12, color: '#9ca3af', fontWeight: 500, marginBottom: 8 }}>{label}</div>
    <div style={{ fontSize: 22, fontWeight: 700, color: accent || NAVY }}>{value}</div>
  </div>
);

export const StatusPill = ({ status }) => (
  <span style={{
    fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 999,
    color: '#fff', background: STATUS_COLORS[status] || '#6b7280', whiteSpace: 'nowrap',
    textTransform: 'capitalize',
  }}>
    {(status || '').replace(/_/g, ' ')}
  </span>
);

export const formatCurrency = (n) => `₹${Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
export const formatDate = (d) => d ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';

function Dashboard() {
  return <ClientPortalLayout title="Dashboard"><DashboardInner /></ClientPortalLayout>;
}

export default Dashboard;
